// ar — checkin/quickCheck/stepTracker blocks translated.
export const ar = {
  "common": {
    "loading": "جارٍ التحميل…",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "edit": "تعديل",
    "close": "إغلاق",
    "confirm": "تأكيد",
    "back": "رجوع",
    "next": "التالي",
    "submit": "إرسال",
    "search": "بحث",
    "select": "اختيار",
    "or": "أو",
    "and": "و",
    "note": "Note",
    "viewAll": "عرض الكل",
    "learnMore": "اعرف المزيد",
    "getStarted": "ابدأ الآن",
    "continue": "متابعة",
    "saving": "جارٍ الحفظ…"
  },
  "offline": {
    "banner": "أنت غير متصل بالإنترنت. قد تكون بعض الميزات محدودة.",
    "savedLocally": "تم الحفظ محلياً — ستتم المزامنة عند الاتصال",
    "syncing": "جاري مزامنة تحديثاتك…",
    "backOnline": "عدت إلى الإنترنت — تمت مزامنة التحديثات"
  },

  "nav": {
    "dashboard": "لوحة التحكم",
    "nutrition": "التغذية الذكية",
    "family": "العائلة",
    "care": "الخدمات",
    "careShort": "الخدمات",
    "checkIn": "تسجيل اليوم",
    "insights": "رؤى صحية",
    "trends": "الاتجاهات",
    "habits": "العادات",
    "medications": "الأدوية",
    "expertSupport": "دعم متخصص",
    "profile": "الملف الشخصي",
    "healthHub": "مركز الصحة",
    "support": "الدعم والمساعدة",
    "wellness": "العافية",
    "education": "التعليم",
    "community": "المجتمع",
    "preventiveHealth": "الصحة الوقائية",
    "womensHealth": "صحة المرأة",
    "reminders": "تذكيرات الصحة",
    "meals": "الوجبات",
    "orders": "الطلبات",
    "subscription": "الاشتراك",
    "logout": "تسجيل الخروج"
  },

  "navShort": {
    "dashboard": "الرئيسية",
    "nutrition": "التغذية",
    "family": "العائلة",
    "care": "الخدمات",
    "support": "الدعم",
    "profile": "الملف"
  },
  "auth": {
    "login": "تسجيل الدخول",
    "register": "إنشاء حساب",
    "logout": "تسجيل الخروج",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "name": "الاسم الكامل",
    "forgotPassword": "هل نسيت كلمة المرور؟",
    "noAccount": "ليس لديك حساب؟",
    "haveAccount": "Already have an account?",
    "signInHere": "Sign in here",
    "signUpHere": "Sign up here",
    "welcomeBack": "مرحبًا بعودتك!",
    "getStarted": "Let's get started",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "vendorLogin": "Vendor Login",
    "createOne": "أنشئ حسابًا",
    "tagline": "اهتم بصحتك — تسجيل بسيط كل يوم.",
    "takes30s": "أقل من 30 ثانية",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "كلمة المرور",
    "checking": "جارٍ التحقّق…",
    "continue": "متابعة",
    "secureMessage": "آمن وخاص — بياناتك محميّة",
    "biometricSoon": "الدخول البيومتري — قريبًا",
    "showPassword": "إظهار كلمة المرور",
    "hidePassword": "إخفاء كلمة المرور",
    "vendor": {
      "title": "تسجيل دخول الشركاء الموردين",
      "subtitle": "الوصول إلى لوحة تحكم الموردين في HealthLoop",
      "businessEmail": "البريد الإلكتروني للعمل",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "جاري تسجيل الدخول...",
      "signIn": "تسجيل الدخول",
      "notVendorYet": "لست شريكاً مورداً بعد؟",
      "registerBusiness": "سجل عملك التجاري",
      "areYouUser": "هل أنت مستخدم؟",
      "userLogin": "تسجيل دخول المستخدم",
      "welcomeBackToast": "مرحباً بعودتك!",
      "genericError": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى."
    },
    "admin": {
      "backToUserLogin": "تسجيل دخول المستخدم",
      "title": "تسجيل دخول المسؤول (Admin)",
      "restrictedBadge": "مقيد",
      "tagline": "وحدة تحكم مشغلي HealthLoop — تتطلب صلاحيات المسؤول.",
      "emailLabel": "البريد الإلكتروني للمسؤول",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "كلمة المرور",
      "passwordPlaceholder": "أدخل كلمة مرور المسؤول",
      "signingIn": "جاري تسجيل الدخول…",
      "submit": "دخول لوحة تحكم المسؤول",
      "secureNote": "اتصال آمن · الجلسة مشفرة",
      "restrictedTitle": "هذه المنطقة مخصصة للمسؤولين فقط.",
      "restrictedBody": "لقد قمت بتسجيل الدخول، ولكن حسابك لا يملك صلاحيات المسؤول. سجل الخروج لتجربة حساب آخر، أو عد إلى التطبيق الرئيسي.",
      "signOut": "تسجيل الخروج",
      "backToApp": "العودة للتطبيق"
    }
  },
  "quickCheck": {
    "header": {
      "title": "كيف تشعر اليوم؟",
      "subtitle": "فحص سريع — يستغرق أقل من 60 ثانية"
    },
    "section1": {
      "title": "ماذا تلاحظ اليوم؟",
      "hint": "(اختر كل ما ينطبق)"
    },
    "environment": {
      "title": "بيئتك اليوم",
      "hint": "ساعدنا على فهم الأجواء المحيطة بك"
    },
    "basicChecks": {
      "title": "فحوصات أساسية سريعة",
      "hint": "اختياري ولكن مفيد"
    },
    "validation": {
      "pickOne": "يرجى الإجابة على سؤال واحد على الأقل"
    },
    "submit": {
      "cta": "احصل على رؤى عافيتي",
      "saving": "جاري الحفظ...",
      "analyzing": "نحلل أنماطك الصحية برفق...",
      "savedToast": "✅ تم حفظ المتابعة! جاري تحليل أنماطك الصحية..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "متتبع الخطوات",
      "subtitle": "تتبع نشاطك بصدق وخصوصية",
      "backToDashboard": "العودة إلى اللوحة الرئيسية"
    },
    "today": {
      "title": "خطوات اليوم",
      "goalProgress": "{{current}} / {{goal}} خطوة",
      "goalReached": "وصلت لهدفك — عمل رائع!",
      "keepGoing": "استمر — أنت في المسار الصحيح."
    },
    "streak": {
      "label": "الاستمرارية الحالية",
      "days": "يوم {{count}}",
      "daysPlural": "{{count}} أيام"
    },
    "badges": {
      "title": "الأوسمة",
      "empty": "ستكسب أوسمة كلما عززت هذه العادة."
    },
    "reminders": {
      "title": "تنبيهات الحركة",
      "hint": "تذكيرات لطيفة للمشي قليلاً عند الجلوس لفترات طويلة.",
      "enabled": "مفعلة",
      "disabled": "معطلة"
    },
    "insights": {
      "weeklyAverage": "المعدل الأسبوعي",
      "weeklyGoal": "الهدف الأسبوعي"
    },
    "actions": {
      "connect": "ربط مصدر للخطوات",
      "manualLog": "تسجيل الخطوات يدوياً",
      "changeGoal": "تغيير الهدف اليومي"
    },
    "offline": {
      "title": "وضع عدم الاتصال نشط",
      "body": "يستمر التتبع حتى عندما تكون غير متصل. سنزامن تحديثاتك عند عودة الاتصال."
    },
    "permission": {
      "title": "اربط جهازك لتتبع الخطوات تلقائياً",
      "body": "اسمح لـ HealthLoop بقراءة بيانات {{platform}}. تبقى بيانات عافيتك على جهازك ما لم تختر مزامنتها.",
      "connect": "ربط",
      "maybeLater": "ربما لاحقاً"
    },
    "sync": {
      "lastSynced": "آخر مزامنة {{time}}",
      "queued": "تحديث {{count}} في انتظار المزامنة.",
      "queuedPlural": "{{count}} تحديثات في انتظار المزامنة.",
      "disconnect": "قطع الاتصال",
      "refreshAria": "تحديث المزامنة"
    },
    "progress": {
      "title": "تقدمك اليوم",
      "stepsToday": "خطوات اليوم",
      "goalLabel": "الهدف: {{goal}}",
      "stepsToGo": "{{remaining}} خطوة متبقية",
      "goalAchieved": "🎉 تم تحقيق الهدف",
      "goalAriaLabel": "تم تحقيق الهدف",
      "statGoal": "الهدف",
      "statProgress": "التقدم",
      "statSource": "المصدر",
      "sourceDevice": "الجهاز",
      "sourceManual": "يدوي"
    },
    "empty": {
      "waiting": "في انتظار بيانات النشاط",
      "startMoving": "ابدأ بالحركة لبدء التتبع",
      "shortWalkHint": "اخطُ خطوات قليلة لتجربة التتبع — أو سجل دخولاً يدوياً أدناه."
    },
    "manual": {
      "title": "تسجيل الخطوات يدوياً",
      "placeholder": "أدخل الخطوات",
      "submit": "تسجيل",
      "footer": "الإدخالات اليدوية تحل محل عدد اليوم. ستتم المزامنة تلقائياً عند الاتصال بالإنترنت."
    },
    "trust": {
      "title": "خصوصية افتراضية",
      "itemData": "تبقى بيانات عافيتك على جهازك ما لم تختر مزامنتها مع حسابك.",
      "itemOffline": "يستمر التتبع حتى عندما تكون غير متصل — تنتظر التحديثات وتتم المزامنة عند عودة الاتصال.",
      "itemNoInvent": "نحن لا نخترع أعداد الخطوات أبداً. فقط القيم من جهازك أو إدخالاتك اليدوية يتم تخزينها."
    },
    "howItWorks": {
      "title": "كيف يعمل",
      "itemConnect": "اربط تطبيق الصحة في جهازك للتتبع التلقائي.",
      "itemManual": "الإدخال اليدوي متاح دائماً كبديل موثوق.",
      "itemOfflineQueue": "تنتظر التحديثات محلياً وتتزامن فور عودة الاتصال.",
      "itemDisconnect": "افصل الاتصال في أي وقت — يبقى سجلك المسجل على هذا الجهاز."
    }
  },
  "checkin": {
    "header": {
      "title": "متابعة حالتك اليومية",
      "subtitle": "يستغرق أقل من 60 ثانية",
      "restDayLink": "لست مستعداً لهذا اليوم"
    },
    "snapshot": {
      "title": "لوحتك المعلوماتية المحدثة",
      "healthScore": "مستوى العافية",
      "todayTasks": "مهام اليوم",
      "dayStreak": "يوم متتالي"
    },
    "resume": {
      "banner": "عدنا من حيث توقفت",
      "startFresh": "ابدأ من جديد",
      "dismiss": "تجاهل"
    },
    "progress": {
      "allSet": "تم الأمر",
      "step": "الخطوة {{current}} من {{total}}",
      "ariaLabel": "تقدم المتابعة اليومية: تم إكمال {{done}} من أصل {{total}} أقسام"
    },
    "insights": {
      "title": "رؤى HealthLoop حول عافيتك",
      "subtitle": "مخصصة لك اليوم",
      "insightForYou": "رؤى تهمك",
      "simpleActions": "خطوات بسيطة يمكنك القيام بها",
      "whenToSeekHelp": "متى تطلب الدعم",
      "nhsAdvice": "إذا كنت قلقاً، تواصل مع طبيبك الخاص أو الجهات المختصة",
      "backToDashboard": "العودة إلى اللوحة الرئيسية",
      "newCheckIn": "متابعة جديدة",
      "disclaimer": "يقدم HealthLoop إرشادات للتوعية، وليس تشخيصاً طبياً."
    },
    "restDay": {
      "title": "الراحة جزء من توازنك.",
      "body": "سنكون هنا غداً، عندما تكون مستعداً.",
      "streakNote": "استمراريتك لم تتأثر — هي فقط في وقت راحة أيضاً.",
      "backToDashboard": "العودة إلى اللوحة الرئيسية",
      "changedMind": "في الواقع، أود المتابعة الآن."
    },
    "feelings": {
      "title": "كيف تشعر اليوم؟",
      "hint": "اختر كل ما ينطبق عليك",
      "tired": "أشعر بالتعب",
      "headache": "صداع",
      "stressed": "مجهد أو مضغوط",
      "pain": "أوجاع أو آلام في الجسم",
      "okay": "أشعر أنني بخير اليوم"
    },
    "basics": {
      "title": "أساسياتك",
      "sleepQ": "هل نمت جيداً الليلة الماضية؟",
      "waterQ": "هل شربت كمية كافية من الماء اليوم؟",
      "foodQ": "هل تناولت وجباتك بشكل جيد اليوم؟",
      "activityQ": "ما مدى نشاطك اليوم؟",
      "yes": "نعم",
      "notReally": "ليس تماماً",
      "notYet": "ليس بعد",
      "notActive": "غير نشط",
      "lightActivity": "نشاط خفيف",
      "active": "نشط"
    },
    "mind": {
      "title": "الذهن والطاقة",
      "stressQ": "ما هو مستوى التوتر لديك اليوم؟",
      "moodQ": "كيف هو مزاجك اليوم؟",
      "energyQ": "كيف هو مستوى طاقتك اليوم؟",
      "low": "منخفض",
      "moderate": "متوسط",
      "high": "مرتفع",
      "neutral": "محايد",
      "good": "جيد",
      "okay": "جيد نوعاً ما"
    },
    "day": {
      "title": "يومك",
      "routineQ": "هل اتبعت روتينك المعتاد اليوم؟",
      "yes": "نعم",
      "no": "لا"
    },
    "environment": {
      "title": "بيئتك اليوم",
      "describeQ": "كيف تصف البيئة المحيطة بك؟",
      "comfortable": "😊 مريحة",
      "slightlyUncomfortable": "😐 غير مريحة قليلاً",
      "challenging": "😓 صعبة",
      "affectedQ": "هل أثرت بيئتك على شعورك؟",
      "yes": "نعم",
      "no": "لا",
      "exposureLabel": "التعرض لـ (اختر كل ما ينطبق)",
      "heat": "🌡️ حرارة",
      "cold": "❄️ برودة",
      "noise": "🔊 ضجيج",
      "dustSmoke": "💨 غبار أو دخان",
      "crowded": "👥 زحام",
      "none": "✅ لا شيء"
    },
    "submit": {
      "analyzing": "نحلل أنماطك الصحية برفق...",
      "cta": "عرض رؤى عافيتي"
    },
    "toast": {
      "savedFull": "تم حفظ المتابعة! تم تحديث لوحتك الرئيسية.",
      "savedShort": "تم حفظ المتابعة."
    }
  },
  "onboarding": {
    "welcome": "أهلًا",
    "completeSetup": "إنهاء الإعداد",
    "stepProgress": "الخطوة {{step}} من {{total}}",
    "percentComplete": "اكتمل {{percent}}٪",
    "welcomeToast": "مرحبًا بك في HealthLoop! تم إعداد ملفك الشخصي.",
    "errorAgeRange": "الرجاء اختيار الفئة العمرية",
    "errorCountry": "الرجاء اختيار بلدك",
    "errorGoal": "الرجاء اختيار هدفك الصحي الرئيسي",
    "errorCuisine": "اختر تفضيلًا غذائيًا واحدًا على الأقل",
    "errorGeneric": "تعذر إتمام الإعداد. الرجاء المحاولة لاحقًا.",
    "step1Title": "مرحبًا بك في HealthLoop! 👋",
    "step1Subtitle": "لنخصّص رحلتك الصحية",
    "ageRangeLabel": "ما هي فئتك العمرية؟",
    "genderLabel": "الجنس (اختياري)",
    "gender_male": "ذكر",
    "gender_female": "أنثى",
    "gender_non-binary": "غير ثنائي",
    "gender_prefer_not_to_say": "أفضّل عدم الإفصاح",
    "step2Title": "أين تقيم؟ 🌍",
    "step2Subtitle": "يساعدنا ذلك على اقتراح وجبات تناسب ثقافتك",
    "countryLabel": "اختر بلدك",
    "country_uk": "المملكة المتحدة",
    "country_nigeria": "نيجيريا",
    "country_ghana": "غانا",
    "country_kenya": "كينيا",
    "country_south_africa": "جنوب أفريقيا",
    "country_usa": "الولايات المتحدة",
    "country_canada": "كندا",
    "country_india": "الهند",
    "country_jamaica": "جامايكا",
    "country_other": "دولة أخرى",
    "step3Title": "ما هو هدفك الرئيسي؟ 🎯",
    "step3Subtitle": "اختر أولويتك الصحية",
    "additionalGoals": "أهداف إضافية؟ (اختياري)",
    "goal_weight_loss": "فقدان الوزن",
    "goalDesc_weight_loss": "إنقاص الوزن بصحة",
    "goal_weight_maintenance": "الحفاظ على الوزن",
    "goalDesc_weight_maintenance": "البقاء على وزنك الحالي",
    "goal_muscle_gain": "بناء العضلات",
    "goalDesc_muscle_gain": "زيادة القوة والكتلة العضلية",
    "goal_general_wellness": "العافية العامة",
    "goalDesc_general_wellness": "تحسين الصحة بشكل عام",
    "goal_better_sleep": "تحسين النوم",
    "goalDesc_better_sleep": "تحسين جودة النوم",
    "goal_reduce_stress": "تقليل التوتر",
    "goalDesc_reduce_stress": "إدارة التوتر بشكل أفضل",
    "goal_increase_energy": "مزيد من الطاقة",
    "goalDesc_increase_energy": "الشعور بمزيد من النشاط",
    "step4Title": "تفضيلات الطعام 🍽️",
    "step4Subtitle": "اختر المطابخ المفضّلة والقيود الغذائية",
    "cuisineLabel": "المطابخ المفضّلة",
    "cuisineHint": "اختر واحدًا على الأقل (يمكنك اختيار أكثر)",
    "dietaryLabel": "القيود الغذائية (اختياري)",
    "diet_vegetarian": "نباتي",
    "diet_vegan": "نباتي صرف",
    "diet_halal": "حلال",
    "diet_kosher": "كوشير",
    "diet_gluten_free": "خالٍ من الجلوتين",
    "diet_dairy_free": "خالٍ من الألبان",
    "diet_pescatarian": "يأكل السمك فقط",
    "step5Title": "الحالات الصحية 🏥",
    "step5Subtitle": "اختياري — يساعدنا على تقديم توصيات أفضل",
    "conditionsLabel": "هل لديك أيٌّ من هذه الحالات؟",
    "conditionsHint": "هذه المعلومات خاصة وتُستخدم فقط لتخصيص تجربتك",
    "condition_diabetes": "السكري",
    "condition_hypertension": "ارتفاع ضغط الدم",
    "condition_heart_disease": "أمراض القلب",
    "condition_thyroid": "مشاكل الغدة الدرقية",
    "condition_celiac": "مرض الاضطرابات الهضمية",
    "condition_ibs": "القولون العصبي",
    "condition_none": "لا يوجد",
    "privacyTitle": "بياناتك محميّة",
    "privacyBody": "تُشفَّر معلوماتك الشخصية وتُخزَّن بأمان. نستخدم هذه البيانات فقط لتخصيص تجربتك بتوصيات وجبات مناسبة ونصائح صحية وإشعارات. لن تتم مشاركة بياناتك مع طرف ثالث دون موافقتك الصريحة.",
    "trackMedication": "أريد تتبّع أدويتي",
    "specialistInterest": "أرغب في استشارات مع متخصّصين",
    "welcomeTitle": "مرحباً بك في HealthLoop! 👋",
    "welcomeSubtitle": "دعنا نخصص لك ذكاءً اصطناعياً متطوراً لصحتك الوقائية ونمط حياتك في خطوات بسيطة",
    "stepLabel": "الخطوة {{current}} من {{total}}",
    "skipForNow": "تخطي الآن",
    "skipToast": "يمكنك إكمال ملفك الشخصي في أي وقت",
    "back": "رجوع",
    "next": "التالي",
    "completing": "جاري الإكمال...",
    "complete": "إتمام الإعداد",
    "successToast": "مرحباً بك في HealthLoop! تم تخصيص ملفك بنجاح 🎉",
    "failureToast": "عذراً، لم نتمكن من إكمال الإعداد",
    "validation": {
      "basicInfo": "يرجى ملء جميع المعلومات الأساسية",
      "pickGoal": "يرجى اختيار هدف صحي واحد على الأقل",
      "pickPrimary": "يرجى تحديد هدفك الأساسي",
      "pickRegion": "يرجى اختيار منطقتك الثقافية للحصول على اقتراحات وجبات تناسبك",
      "pickFocus": "يرجى اختيار تركيزك الصحي الرئيسي"
    },
    "step1": {
      "title": "ملفك الصحي",
      "description": "ساعدنا في بناء ذكاء صحي مخصص لك",
      "age": "العمر *",
      "agePlaceholder": "مثلاً: 30",
      "height": "الطول (سم) *",
      "heightPlaceholder": "مثلاً: 170",
      "weight": "الوزن (كجم) *",
      "weightPlaceholder": "مثلاً: 70"
    },
    "step2": {
      "title": "أهدافك الصحية",
      "description": "اختر كل ما يهمك، ثم حدد هدفك الأساسي",
      "primaryLabel": "اختر هدفك الأساسي *",
      "primaryBadge": "الأساسي"
    },
    "step3": {
      "title": "🌍 التفضيلات الثقافية والغذائية",
      "description": "ساعدنا في تقديم توصيات وجبات تناسب ذوقك",
      "regionLabel": "المنطقة الثقافية *",
      "regionHint": "اختر خلفيتك الثقافية للحصول على اقتراحات وجبات مألوفة",
      "countryLabel": "الدولة (اختياري)",
      "countryPlaceholder": "مثلاً: السعودية، مصر، المغرب",
      "countryHint": "للحصول على توصيات أكثر دقة",
      "foodPrefLabel": "تفضيل تنوع الطعام"
    },
    "step4": {
      "title": "التركيز الصحي الرئيسي",
      "description": "اختر المجال الذي تود التركيز عليه أكثر من غيره"
    },
    "step5": {
      "title": "تفضيلاتك",
      "description": "خصص تجربتك في HealthLoop",
      "trackMeds": "تتبع الفيتامينات والمكملات",
      "trackMedsHint": "تفعيل التذكيرات والمتابعة اليومية",
      "specialist": "الاهتمام بدعم المتخصصين",
      "specialistHint": "احصل على وصول لخبراء العافية، أخصائيي التغذية، وخبراء الصحة النفسية",
      "confidentialTitle": "دعم سري وآمن:",
      "confidentialBody": "جميع معلوماتك محمية وتُستخدم فقط لتقديم رؤى صحية وقائية مخصصة لك."
    },
    "step6": {
      "title": "تخصيص الوجبات",
      "description": "ساعدنا في اقتراح وجبات تطابق ذوقك واحتياجاتك الغذائية",
      "cuisinesLabel": "المطابخ المفضلة (اختياري)",
      "cuisinesHint": "اختر أنواع المطابخ التي تستمتع بها",
      "dietaryLabel": "القيود الغذائية (اختياري)",
      "dietaryHint": "اختر أي قيود تتبعها",
      "allergiesLabel": "أنواع الحساسية الشائعة (اختياري)",
      "allergiesHint": "حدد أي مسببات حساسية غذائية",
      "personalisedTitle": "وجبات مخصصة:",
      "personalisedBody": "سنستخدم هذه التفضيلات لاقتراح وجبات تناسب ذوقك. يمكنك دائماً تحديثها لاحقاً من الإعدادات."
    },
    "healthGoals": {
      "better_sleep": "نوم أفضل",
      "reduce_stress": "تقليل التوتر",
      "increase_energy": "زيادة الطاقة",
      "weight_management": "إدارة الوزن",
      "improve_fitness": "تحسين اللياقة",
      "better_nutrition": "تغذية أفضل",
      "mental_wellness": "العافية النفسية",
      "chronic_condition": "تعزيز الصحة العامة"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "الصحة النفسية",
        "description": "التركيز على المزاج، التوتر، والراحة النفسية"
      },
      "physical_fitness": {
        "label": "اللياقة البدنية",
        "description": "التركيز على التمارين، القوة، والنشاط"
      },
      "nutrition": {
        "label": "التغذية",
        "description": "التركيز على النظام الغذائي والوجبات الصحية"
      },
      "sleep": {
        "label": "جودة النوم",
        "description": "التركيز على الراحة، أنماط النوم، والاستشفاء"
      },
      "stress_management": {
        "label": "إدارة الضغوط",
        "description": "التركيز على الاسترخاء وتقليل التوتر"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "غرب أفريقيا",
        "description": "المطبخ النيجيري، الغاني، والسنغالي"
      },
      "east_african": {
        "label": "شرق أفريقيا",
        "description": "المطبخ الكيني، الإثيوبي، والتنزاني"
      },
      "north_african": {
        "label": "شمال أفريقيا",
        "description": "المطبخ المغربي، والمصري"
      },
      "southern_african": {
        "label": "جنوب أفريقيا",
        "description": "مطبخ جنوب أفريقيا"
      },
      "caribbean": {
        "label": "منطقة الكاريبي",
        "description": "المطبخ الجامايكي، والترينيدادي"
      },
      "middle_eastern": {
        "label": "الشرق الأوسط",
        "description": "المطبخ اللبناني، الفلسطيني، والسوري"
      },
      "south_asian": {
        "label": "جنوب آسيا",
        "description": "المطبخ الهندي، الباكستاني، والبنغلاديشي"
      },
      "east_asian": {
        "label": "شرق آسيا",
        "description": "المطبخ الصيني، الياباني، والكوري"
      },
      "southeast_asian": {
        "label": "جنوب شرق آسيا",
        "description": "المطبخ التايلاندي، الفيتنامي، والإندونيسي"
      },
      "western": {
        "label": "غربي",
        "description": "المطبخ الأمريكي، والأوروبي"
      },
      "latin_american": {
        "label": "أمريكا اللاتينية",
        "description": "المطبخ المكسيكي، البرازيلي، والأرجنتيني"
      },
      "mediterranean": {
        "label": "حوض المتوسط",
        "description": "المطبخ اليوناني، الإيطالي، والإسباني"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "تقليدي",
        "description": "وجبات من منطقتك الثقافية غالباً"
      },
      "mixed": {
        "label": "مختلط",
        "description": "توازن بين الأطباق المحلية والعالمية"
      },
      "international": {
        "label": "عالمي",
        "description": "مطابخ متنوعة من حول العالم"
      }
    },
    "cuisines": {
      "west_african": "غرب أفريقيا",
      "caribbean": "الكاريبي",
      "mediterranean": "حوض المتوسط",
      "asian": "آسيوي",
      "western": "غربي",
      "indian": "هندي",
      "middle_eastern": "شرق أوسطي",
      "general": "جميع المطابخ"
    },
    "dietary": {
      "vegetarian": "نباتي",
      "vegan": "نباتي صرف",
      "pescatarian": "نباتي مع سمك",
      "gluten_free": "خالٍ من الغلوتين",
      "dairy_free": "خالٍ من الألبان",
      "low_carb": "قليل الكربوهيدرات"
    },
    "allergies": {
      "nuts": "المكسرات",
      "shellfish": "المأكولات البحرية",
      "dairy": "الألبان",
      "eggs": "البيض",
      "soy": "الصويا",
      "gluten": "الغلوتين"
    },
    "cuisine_nigerian": "نيجيري",
    "cuisine_ghanaian": "غاني",
    "cuisine_senegalese": "سنغالي",
    "cuisine_kenyan": "كيني",
    "cuisine_ethiopian": "إثيوبي",
    "cuisine_moroccan": "مغربي",
    "cuisine_south_african": "جنوب أفريقي",
    "cuisine_jamaican": "جامايكي",
    "cuisine_trinidadian": "ترينيدادي",
    "cuisine_lebanese": "لبناني",
    "cuisine_turkish": "تركي",
    "cuisine_greek": "يوناني",
    "cuisine_italian": "إيطالي",
    "cuisine_french": "فرنسي",
    "cuisine_british": "بريطاني",
    "cuisine_indian_south": "هندي جنوبي",
    "cuisine_indian_north": "هندي شمالي",
    "cuisine_pakistani": "باكستاني",
    "cuisine_japanese": "ياباني",
    "cuisine_chinese": "صيني",
    "cuisine_korean": "كوري",
    "cuisine_vietnamese": "فيتنامي",
    "cuisine_thai": "تايلاندي",
    "cuisine_filipino": "فلبيني",
    "cuisine_american": "أمريكي",
    "cuisine_mexican": "مكسيكي",
    "cuisine_brazilian": "برازيلي",
    "cuisine_peruvian": "بيروفي"
  },
  "dashboard": {
    "welcome": "مرحبًا بعودتك",
    "greeting": "أهلًا",
    "goodMorning": "صباح الخير",
    "goodAfternoon": "طاب يومك",
    "goodEvening": "مساء الخير",
    "tagline": "خطوات صحية صغيرة تصنع تغييرًا دائمًا",
    "microcopy": "رحلتك نحو العافية مهمّة.",
    "welcomeSubtitleMorning1": "بداية يوم هادئة.",
    "welcomeSubtitleMorning2": "سعداء بزيارتك هذا الصباح.",
    "welcomeSubtitleMorning3": "اللحظات الصغيرة تتراكم.",
    "welcomeSubtitleAfternoon1": "نتمنّى لك يومًا مستقرًا.",
    "welcomeSubtitleAfternoon2": "مرحبًا بعودتك إلى HealthLoop.",
    "welcomeSubtitleAfternoon3": "خذ نَفَسًا عميقًا — أنت بخير.",
    "welcomeSubtitleEvening1": "نختم اليوم معًا.",
    "welcomeSubtitleEvening2": "خاتمة لطيفة لليوم.",
    "welcomeSubtitleEvening3": "مرحبًا بعودتك هذا المساء.",
    "title": "منصتك للصحة الوقائية",
    "subtitle": "تابع وتعلّم وتصرّف قبل تفاقم المشاكل",
    "summary": "ملخّص صحتك",
    "summaryDesc": "Real-time insights across prevention, education, engagement, and wellness",
    "comprehensiveSupport": "Comprehensive support across prevention, education, engagement, and wellness",
    "todayCheckIn": "تسجيل اليوم",
    "quickActions": "إجراءات سريعة",
    "healthOverview": "نظرة عامة على الصحة",
    "recentActivity": "Recent Activity",
    "viewAll": "عرض الكل",
    "preventiveHealth": "الصحة الوقائية",
    "preventiveHealthDesc": "Daily tracking, wellness monitoring & preventive alerts",
    "education": "التعليم",
    "educationDesc": "Evidence-based insights, health articles & expert guidance",
    "engagement": "المشاركة",
    "engagementDesc": "Community challenges, habit tracking & social support",
    "wellness": "العافية",
    "wellnessDesc": "Smart nutrition, lifestyle balance & holistic well-being",
    "todaysInsight": "فكرة اليوم",
    "wellnessScore": "مؤشر العافية",
    "healthStreak": "سلسلة الإنجاز الصحي",
    "days": "أيام",
    "logHealth": "تسجيل الصحة",
    "getEducated": "تعلّم",
    "communityChallenge": "Community Challenge",
    "checkWellness": "تحقّق من العافية",
    "verified": "موثّق",
    "joinCommunity": "Join Community",
    "personalizedPlan": "خطة مخصّصة",
    "score": "النتيجة",
    "checkIns": "check-ins",
    "habits": "habits",
    "preventive": "Preventive",
    "healthMetrics": "Health Metrics",
    "trackMetrics": "Track Metrics",
    "startTracking": "Start tracking",
    "logMetrics": "Log Metrics",
    "dailyInsight": "Daily Insight",
    "learnAbout": "Learn about preventive health today",
    "articlesAvailable": "articles available",
    "browseArticles": "Browse Articles",
    "currentStreak": "Current Streak",
    "keepGoing": "Keep it going!",
    "startStreak": "Start your streak",
    "checkIn": "سجّل الآن",
    "nutritionPlan": "Nutrition Plan",
    "mealsPlanned": "meals planned",
    "viewPlan": "View Plan",
    "planYourWeek": "Plan your week",
    "moodStress": "المزاج والتوتر",
    "howFeeling": "كيف تشعر؟",
    "logWellness": "Log Wellness",
    "medications": "الأدوية",
    "noMeds": "No meds tracked",
    "addMedications": "Add your medications",
    "daysTracked": "Days Tracked",
    "noHabits": "No habits yet",
    "startTrackingHabits": "Start tracking habits",
    "insights": "Insights",
    "noInsights": "No insights yet",
    "completeFirstPlan": "Complete your first plan",
    "noCheckIns": "No check-ins yet",
    "startFirstCheckIn": "Start your first check-in"
  },
  "support": {
    "title": "الدعم",
    "subtitle": "ابحث عن إجابات، تواصل معنا، أو أبلغ عن مشكلة",
    "backToSettings": "العودة إلى الإعدادات",
    "privacyBanner": "تُعالج طلبات الدعم بسرية تامة. تبقى بياناتك الصحية محمية.",
    "section1": "القسم ١",
    "section2": "القسم ٢",
    "section3": "القسم ٣",
    "section4": "القسم ٤",
    "navHelpCenter": "مركز المساعدة",
    "navContact": "التواصل مع الدعم",
    "navHealth": "خدمات صحية",
    "navTechnical": "دعم تقني",
    "helpCenterTitle": "مركز المساعدة",
    "helpCenterSubtitle": "ابحث في الأسئلة الشائعة واحصل على إجابات سريعة.",
    "contactTitle": "التواصل مع الدعم",
    "contactSubtitle": "اختر وسيلة التواصل المفضّلة لديك.",
    "healthServicesTitle": "خدمات صحية",
    "healthServicesSubtitle": "تواصل مع خدمات متابعة الأدوية والاستشارات السريرية.",
    "technicalTitle": "دعم تقني",
    "technicalSubtitle": "أبلغ عن خلل أو مشكلة تقنية مع التفاصيل المطلوبة.",
    "searchPlaceholder": "ابحث في الأسئلة الشائعة…",
    "liveChat": "دردشة مباشرة",
    "emailUs": "راسلنا عبر البريد",
    "callBack": "Schedule a callback",
    "sendMessage": "إرسال رسالة",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "اسمك",
    "yourEmail": "بريدك الإلكتروني",
    "subject": "الموضوع",
    "message": "الرسالة",
    "phone": "Phone",
    "description": "Description",
    "submit": "إرسال",
    "successTitle": "تم إرسال رسالتك",
    "successDescription": "سنرد عليك خلال ٢٤–٤٨ ساعة.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "التغذية الذكية",
    "basedOnGoal": "وفقًا لهدفك:",
    "personalizedData": "Personalized based on your recent health data",
    "evidenceBased": "Evidence-based nutrition as part of your preventive health plan",
    "todaysMealSuggestions": "اقتراحات وجبات اليوم",
    "customize": "تخصيص",
    "breakfast": "الإفطار",
    "lunch": "الغداء",
    "dinner": "العشاء",
    "loadingBreakfast": "Loading breakfast...",
    "loadingLunch": "Loading lunch...",
    "loadingDinner": "Loading dinner...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "تبديل الوجبة",
    "healthyOptionsNearYou": "خيارات صحية قريبة منك",
    "enableLocation": "Enable location",
    "view": "عرض",
    "discoverOptions": "Discover healthy restaurants, grocery stores, and meal prep vendors near you",
    "cuisinesSelected": "cuisines selected",
    "cuisineSelected": "cuisine selected",
    "dietaryPrefs": "dietary prefs",
    "dietaryPref": "dietary pref",
    "customizeMeals": "تخصيص الوجبات",
    "subtitleAdaptive": "تخطيط وجبات يحترم ثقافتك ويتوافق مع أهدافك الصحية",
    "hideFavorites": "إخفاء المفضّلة",
    "viewFavorites": "عرض المفضّلة",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "عرض الخطة الكاملة",
    "exploreRecipes": "تصفّح الوصفات"
  },
  "location": {
    "permissionTitle": "Find healthy options near you",
    "permissionDesc": "Used to recommend restaurants, grocery stores, and meal prep vendors aligned with your health goals.",
    "howToEnable": "How to enable:",
    "step1": "Click the lock icon 🔒 in your browser's address bar",
    "step2": "Find \"Location\" permissions",
    "step3": "Change to \"Allow\"",
    "step4": "Refresh this page",
    "refreshPage": "Refresh Page",
    "allowLocation": "Allow Location",
    "notNow": "Not now",
    "denied": "Location access was blocked. To see nearby healthy options, you'll need to enable location permissions.",
    "unavailable": "Location information is currently unavailable. Please check your device settings.",
    "error": "Unable to access your location. Please try again or check browser settings.",
    "unsupported": "Your browser doesn't support location services. Try using a modern browser like Chrome, Firefox, or Safari.",
    "accessRequired": "Location Access Required"
  },
  "womensHealth": {
    "title": "Women's Health",
    "description": "Track your cycle, log symptoms, and get personalized wellness tips based on your cycle phase",
    "cycleTracking": "Cycle Tracking",
    "symptomLogging": "Symptom Logging",
    "phaseInsights": "Phase Insights",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Insights",
    "tips": "Health Tips",
    "overview": "Overview",
    "history": "History",
    "startTracking": "Start Tracking Your Cycle"
  },
  "profile": {
    "title": "الملف الشخصي",
    "personalInfo": "المعلومات الشخصية",
    "healthProfile": "الملف الصحي",
    "preferences": "التفضيلات",
    "language": "اللغة",
    "selectLanguage": "اختر اللغة",
    "notifications": "الإشعارات",
    "privacy": "الخصوصية",
    "security": "الأمان",
    "quickAccess": "وصول سريع",
    "editProfile": "تعديل الملف الشخصي",
    "viewStats": "عرض الإحصائيات",
    "backToDashboard": "العودة إلى لوحة التحكم",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "الدعم والمساعدة",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "أرسل ملاحظاتك",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "الإبلاغ عن مشكلة",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "معلومات أساسية",
    "fullName": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "dateOfBirth": "تاريخ الميلاد",
    "gender": "الجنس",
    "height": "الطول (سم)",
    "weight": "الوزن (كغ)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "account": "Account",
    "appearance": "Appearance",
    "languageSettings": "Language Settings",
    "changeLanguage": "Change Language",
    "languageNote": "بعض اللغات الجديدة مترجمة بالذكاء الاصطناعي وفي انتظار مراجعة المتحدثين الأصليين.",
    "languageUpdated": "Language updated successfully",
    "starterBadge": "نسخة أولية",
    "starterBadgeTooltip": "مترجم آلياً — قيد المراجعة من قبل متحدثين أصليين.",
    "regions": {
      "global": "عالمي",
      "european": "اللغات الأوروبية",
      "middleEastern": "لغات الشرق الأوسط",
      "asian": "اللغات الآسيوية",
      "african": "اللغات الأفريقية"
    }
  },
  "search": {
    "triggerLabel": "بحث في HealthLoop",
    "triggerHint": "جرب \"خطوات\"، \"صيدلية\" أو \"حمل\"",
    "triggerAriaLabel": "فتح البحث العام",
    "placeholder": "ابحث عن الميزات، أجهزة التتبع، الدعم…",
    "inputAriaLabel": "البحث في ميزات HealthLoop",
    "modalAriaLabel": "بحث في HealthLoop",
    "close": "إغلاق",
    "clear": "مسح",
    "clearAriaLabel": "مسح البحث",
    "recentSearches": "عمليات البحث الأخيرة",
    "tryFor": "جرب البحث عن",
    "findFeatures": "اعثر على أي ميزة في ثوانٍ.",
    "searchAcross": "البحث في",
    "and": "و",
    "sections": {
      "home": "الرئيسية",
      "nutrition": "التغذية",
      "family": "العائلة",
      "services": "الخدمات",
      "support": "الدعم",
      "profile": "الملف الشخصي"
    },
    "noMatchesFor": "لا توجد نتائج لـ \"{{query}}\"",
    "trySimpler": "جرب كلمة أبسط مثل \"خطوات\"، \"تغذية\" أو \"أخصائي\".",
    "comingSoonBadge": "قريباً",
    "escToClose": "للإغلاق",
    "resultSingular": "نتيجة {{count}}",
    "resultPlural": "{{count}} نتائج",
    "searchAcrossApp": "البحث في التطبيق بالكامل"
  },
  "familyMember": {
    "confirmRemove": "هل تريد إزالة {{name}} من تتبع صحة العائلة؟",
    "removed": "تمت إزالة {{name}} من العائلة",
    "removeFailed": "فشل في إزالة العضو",
    "viewDetails": "عرض التفاصيل",
    "edit": "تعديل",
    "remove": "إزالة",
    "yearsSuffix": "سنوات",
    "healthGoalsLabel": "الأهداف الصحية:",
    "moreSuffix": "أكثر",
    "activeInsights": "رؤى نشطة",
    "viewAllInsights": "عرض كافة الرؤى ({{count}}) ←",
    "viewFullProfile": "عرض الملف الصحي الكامل",
    "lifeStage": {
      "infant": "رضيع (0-2)",
      "toddler": "طفل دارج (2-5)",
      "child": "طفل (6-12)",
      "adolescent": "مراهق (13-17)",
      "adult": "بالغ (18-59)",
      "senior": "كبار السن (60+)",
      "unknown": "غير معروف"
    }
  },
  "profileDeep": {
    "backToDashboard": "العودة إلى لوحة التحكم",
    "profileCompletion": "اكتمال الملف الشخصي",
    "healthSummary": "ملخّص صحّتك",
    "sectionA": "القسم أ",
    "sectionB": "القسم ب",
    "sectionC": "القسم ج",
    "sectionD": "القسم د",
    "personalDetails": "البيانات الشخصية",
    "healthInformation": "المعلومات الصحية",
    "accountSettings": "إعدادات الحساب",
    "fullName": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "dob": "تاريخ الميلاد",
    "gender": "الجنس",
    "genderPlaceholder": "مثل: أنثى، ذكر، غير ثنائي",
    "height": "الطول (سم)",
    "heightPlaceholder": "مثل: 170",
    "weight": "الوزن (كغ)",
    "weightPlaceholder": "مثل: 70",
    "allergies": "الحساسية",
    "allergiesPlaceholder": "مثل: فول سوداني",
    "medicalConditions": "الحالات الطبية",
    "conditionsPlaceholder": "مثل: ارتفاع ضغط الدم",
    "medications": "الأدوية",
    "medicationsPlaceholder": "مثل: ليسينوبريل 10 ملغ يوميًا",
    "emergencyContact": "جهة اتصال الطوارئ",
    "emergencyOptional": "(اختياري)",
    "emergencyPlaceholder": "مثل: أمي +966-50-000-0000",
    "emergencyNote": "يُضمَّن فقط عند مشاركة بياناتك مع طبيب وبموافقتك.",
    "saveChanges": "حفظ التغييرات",
    "saving": "جارٍ الحفظ…",
    "editProfile": "تعديل الملف",
    "cancelEditing": "إلغاء التعديل",
    "healthScore": "مؤشر الصحة",
    "streak": "سلسلة الإنجاز",
    "streakDays": "{{n}} أيام",
    "memberSince": "عضو منذ",
    "remindersActive": "تذكيرات مفعّلة",
    "conditionsTracked": "حالات مُتابَعة",
    "nextAgenda": "في جدول أعمالك",
    "notificationsReminders": "الإشعارات والتذكيرات",
    "notificationsRemindersDesc": "إدارة مواعيد التذكير وقنواته",
    "emailNudges": "تنبيهات بالبريد",
    "emailNudgesDesc": "تذكيرات لطيفة وموجز أسبوعي",
    "on": "مُفعَّل",
    "paused": "متوقّف",
    "privacySecurity": "الخصوصية والأمان",
    "privacySecurityDesc": "حدِّث كلمة المرور لحماية حسابك",
    "preferencesTitle": "التفضيلات",
    "preferencesDesc": "اللغة والمنطقة والتخصيص",
    "supportHelp": "المساعدة والدعم",
    "supportHelpDesc": "ابحث عن الإجابات أو تواصل مع الدعم",
    "sectionAccount": "الحساب",
    "sectionSupport": "الدعم",
    "sectionAbout": "حول التطبيق",
    "sectionAdmin": "المشرف",
    "privacyPolicy": "سياسة الخصوصية",
    "terms": "الشروط",
    "appVersion": "إصدار التطبيق",
    "giveFeedback": "أرسل ملاحظاتك",
    "giveFeedbackDesc": "أخبرنا بما يمكن تحسينه",
    "reportProblem": "الإبلاغ عن مشكلة",
    "reportProblemDesc": "وجدت خللاً؟ أخبرنا",
    "adminInsights": "إحصاءات المسؤول",
    "adminInsightsDesc": "تحليلات التفاعل",
    "adminBadge": "مسؤول",
    "shareWithClinician": "مشاركة مع طبيب",
    "shareWithClinicianDesc": "ملخّص للقراءة فقط · ينتهي تلقائيًا · يمكن إلغاؤه في أي وقت",
    "share": "مشاركة",
    "profileMayBeOutOfDate": "قد يكون الملف الشخصي قديمًا",
    "profileMayBeOutOfDateDesc": "حافظ على دقة بياناتك لتلقّي توجيهات أفضل — حتى تعديلات بسيطة (الوزن أو الأدوية) تساعدنا على تخصيص تذكيراتك.",
    "updateNow": "حدِّث الآن",
    "profileUpdateError": "تعذّر تحديث التفضيلات. حاول مجددًا.",
    "healthLoopUser": "مستخدم HealthLoop",
    "updatedLabel": "حُدِّث",
    "noEntries": "لا توجد إدخالات بعد.",
    "completionComplete": "ملفّك مكتمل. يمكننا تقديم أفضل توجيه. 💚",
    "completionAlmostThere": "تقترب من النهاية. بعض التفاصيل تكشف رؤى أدقّ.",
    "completionInProgress": "أكمل ملفّك للحصول على رؤى عافية أفضل.",
    "justNow": "الآن",
    "minAgo": "قبل {{n}} دقيقة",
    "minsAgo": "قبل {{n}} دقائق",
    "hourAgo": "قبل {{n}} ساعة",
    "hoursAgo": "قبل {{n}} ساعات",
    "dayAgo": "قبل {{n}} يوم",
    "daysAgo": "قبل {{n}} أيام",
    "checkinDueToday": "تسجيل اليوم مستحقّ",
    "checkinDueTonight": "تسجيل هذا المساء مستحقّ"
  },
  "supportDeep": {
    "backToSettings": "العودة إلى الإعدادات",
    "quickNavAria": "أقسام الدعم",
    "searchPlaceholder": "ابحث عن مساعدة…",
    "searchAria": "بحث في الأسئلة الشائعة",
    "resultsCount": "{{n}} نتيجة",
    "resultsCountPlural": "{{n}} نتائج",
    "questionsCount": "{{n}} سؤال",
    "liveChatTitle": "الدردشة المباشرة",
    "liveChatDesc": "تواصل معنا فورًا · الإثنين–الجمعة 9 صباحًا – 6 مساءً",
    "startChat": "بدء الدردشة",
    "liveChatSoonToast": "الدردشة المباشرة قريبًا. حتى ذلك الحين، البريد الإلكتروني خيار ممتاز.",
    "emailUsTitle": "راسلنا",
    "emailUsDesc": "الرد خلال 24–48 ساعة",
    "copy": "نسخ",
    "emailCopied": "نُسِخ البريد إلى الحافظة.",
    "contactFormTitle": "نموذج التواصل",
    "contactFormDesc": "أرسل لنا رسالة — سنرد بالبريد.",
    "yourNameLabel": "اسمك *",
    "namePlaceholder": "محمد أحمد",
    "yourEmailLabel": "بريدك *",
    "emailPlaceholder": "mohammad@example.com",
    "subjectOptional": "الموضوع (اختياري)",
    "subjectPlaceholder": "كيف يمكننا المساعدة؟",
    "messageLabel": "الرسالة *",
    "messagePlaceholder": "اكتب لنا باختصار ما تحتاجه.",
    "sending": "جارٍ الإرسال…",
    "sendMessage": "إرسال الرسالة",
    "messageSent": "تم إرسال الرسالة",
    "messageSentDesc": "سنرد خلال 24–48 ساعة.",
    "callbackTitle": "اطلب اتصالاً",
    "callbackDesc": "سنتصل بك في الوقت المناسب لك.",
    "phoneLabel": "رقم الهاتف *",
    "phonePlaceholder": "+966 50 000 0000",
    "preferredTimeLabel": "الوقت المفضّل (اختياري)",
    "preferredTimePlaceholder": "مثلاً: غدًا بعد الظهر",
    "reasonLabel": "السبب (اختياري)",
    "reasonPlaceholder": "باختصار، عمّ تودّ التحدث؟",
    "submitting": "جارٍ الإرسال…",
    "requestCallback": "طلب الاتصال",
    "callbackRequested": "تم تسجيل طلب الاتصال",
    "callbackRequestedDesc": "سنتواصل معك خلال 24 ساعة.",
    "medicationSupport": "دعم الأدوية",
    "medicationSupportDesc": "تابع الوصفات والتجديد والتذكيرات.",
    "goToMedications": "إلى الأدوية ←",
    "specialistConsultation": "استشارة أخصّائي",
    "specialistConsultationDesc": "تواصل مع طبيب للحصول على إرشاد صحي مخصّص.",
    "connectExpert": "تواصل مع خبير ←",
    "videoConsult": "استشارة بالفيديو",
    "videoConsultDesc": "احجز جلسة فيديو مع أخصّائي.",
    "bookConsultation": "حجز استشارة ←",
    "premium": "مميّز",
    "healthDisclaimer": "يدعم HealthLoop عافيتك اليومية — لا يحلّ محل الرعاية الطبية العاجلة. في الحالات الطارئة اتّصل بالخدمات المحلية.",
    "categoryLabel": "الفئة",
    "catBug": "خلل / خطأ",
    "catPerformance": "أداء بطيء",
    "catFeature": "ميزة لا تعمل",
    "catUi": "مشكلة عرض",
    "catOther": "أخرى",
    "issueTitle": "عنوان المشكلة *",
    "issueTitlePlaceholder": "ملخّص قصير",
    "detailedDescription": "الوصف التفصيلي *",
    "detailedDescriptionPlaceholder": "ماذا حدث؟ ماذا كنت تفعل؟ خطوات إعادة الإنتاج تساعدنا كثيرًا.",
    "autoAttachNote": "تُرفَق معلومات الجهاز والمتصفّح والنافذة تلقائيًا.",
    "submitReport": "إرسال البلاغ",
    "reportSubmitted": "تم إرسال البلاغ",
    "reportSubmittedDesc": "فريقنا يعمل على المشكلة.",
    "fillAllFields": "الرجاء تعبئة جميع الحقول المطلوبة",
    "problemReportSubmittedToast": "تم استلام البلاغ. سندرسه ونتواصل معك قريبًا.",
    "messageSentToast": "تم إرسال الرسالة. سنرد خلال 24–48 ساعة.",
    "callRequestedToast": "تم استلام طلب الاتصال. سنتواصل معك خلال 24 ساعة.",
    "submitFailGeneric": "تعذّر الإرسال. حاول مجددًا أو راسلنا على {{email}}.",
    "submitFailContact": "تعذّر الإرسال. راسلنا مباشرة على {{email}}."
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "الملف الصحي",
    "notifications": "الإشعارات",
    "familyAccounts": "حسابات العائلة",
    "settings": "الإعدادات",
    "logout": "تسجيل الخروج",
    "allCaughtUp": "لقد أنجزت كل شيء.",
    "weekInReview": "مراجعة أسبوعك",
    "dismissNotification": "تجاهل الإشعار",
    "dismissWeeklyDigest": "تجاهل الملخّص الأسبوعي",
    "notificationsAria": "الإشعارات",
    "profileMenuAria": "فتح قائمة الحساب",
    "loadingWellness": "جارٍ تحميل ملخّص عافيتك",
    "nextTip": "النصيحة التالية",
    "todayAtGlance": "يومك في لمحة",
    "healthScoreLabel": "مؤشر الصحة",
    "currentStreakLabel": "السلسلة الحالية",
    "todaysProgress": "تقدّمك اليوم",
    "insightForYou": "نصيحة لك",
    "checkMyHealthRisk": "افحص خطر صحّتي",
    "quickAccess": "وصول سريع",
    "familyCare": "رعاية العائلة",
    "healthLibrary": "مكتبة الصحة",
    "myHealthData": "بياناتي الصحية",
    "askQuestion": "اطرح سؤالاً",
    "dashLoadError": "تعذّر تحميل لوحتك. حاول مجددًا.",
    "taskUpdateError": "تعذّر تحديث المهمّة. حاول مجددًا.",
    "perfectDay": "يوم رائع! 🎉 امتدّت السلسلة.",
    "letsStart": "لنبدأ",
    "yourNextStepToday": "خطوتك التالية اليوم",
    "completeDailyCheck": "أكمل تسجيلك اليومي الصحّي",
    "startDailyCheck": "بدء التسجيل اليومي",
    "viewAll": "عرض الكل",
    "graceProtected": "حماية مؤقّتة",
    "todaysHealthRecommendations": "توصيات اليوم الصحية",
    "updateViaCheck": "تحديث عبر التسجيل اليومي",
    "healthInsight": "نصيحة صحية",
    "riskCheckSubtext": "احصل على رؤى صحية مخصّصة في ثوانٍ",
    "foodDiet": "الطعام والحمية",
    "healthScoreNew": "مؤشر الصحة · جديد",
    "letsBuildScore": "لنبنِ مؤشّر صحّتك معًا",
    "oneHealthyHabitAtATime": "عادة صحية واحدة في كل مرة.",
    "nextCheck": "التسجيل التالي:",
    "todayAt8pm": "اليوم في 8 مساءً",
    "wellnessTipForYou": "نصيحة العافية اليوم · لك",
    "wellnessTipForFactor": "نصيحة العافية اليوم · لـ{{factor}}",
    "logged": "مُسجَّل",
    "gotIt": "فهمت 👍",
    "gladToSeeYou": "سعداء بزيارتك اليوم 💚",
    "takesLessThan60Sec": "أقل من 60 ثانية",
    "scoreReadyWhenYou": "جاهزون متى كنت كذلك",
    "scoreCompleteFirstCheck": "أكمِل أوّل تسجيل لفتح رؤى مخصّصة.",
    "scoreExcellent": "ممتاز",
    "scoreSupportExcellent": "أنت في حالة رائعة اليوم. واصل!",
    "scoreGood": "جيّد",
    "scoreSupportGood": "تسير بشكل جيد. حافظ على عاداتك الصحية.",
    "scoreModerate": "متوسّط",
    "scoreSupportModerate": "الأمور لا بأس بها، ولكن بعض الجوانب تحتاج اهتمامًا.",
    "scoreNeedsAttention": "يحتاج اهتمامًا",
    "scoreSupportNeedsAttention": "صحتك تحتاج اهتمامًا اليوم. تغييرات بسيطة قد تساعد."
  },
  "emailVerify": {
    "bannerWithEmail": "يُرجى تأكيد بريدك ({{email}}) للحفاظ على حسابك آمنًا ولاستلام تذكيراتك.",
    "bannerNoEmail": "يُرجى تأكيد بريدك للحفاظ على حسابك آمنًا ولاستلام تذكيراتك.",
    "sending": "جارٍ الإرسال…",
    "resend": "إعادة إرسال",
    "sentToast": "تم إرسال بريد التأكيد. تحقّق من صندوق الوارد.",
    "sendFailToast": "تعذّر إرسال البريد. حاول لاحقًا."
  },
  "forgotPassword": {
    "title": "هل نسيت كلمة المرور؟",
    "subtitle": "لا تقلق! أدخل بريدك وسنرسل لك تعليمات إعادة التعيين.",
    "emailLabel": "البريد الإلكتروني",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "إرسال رابط إعادة التعيين",
    "sending": "جارٍ الإرسال…",
    "backToLogin": "العودة إلى تسجيل الدخول",
    "resendLink": "إعادة إرسال البريد",
    "successTitle": "تحقّق من بريدك",
    "successBody": "إذا كان هناك حساب لـ {{email}}، فقد أرسلنا رابط إعادة التعيين.",
    "linkExpires": "سينتهي الرابط خلال 30 دقيقة.",
    "successToast": "تحقّق من بريدك للحصول على التعليمات",
    "errEmptyEmail": "الرجاء إدخال بريدك الإلكتروني",
    "errInvalidEmail": "الرجاء إدخال بريد إلكتروني صالح",
    "errNetwork": "تعذّر الاتصال بالخادم. تحقّق من اتصالك وحاول مجددًا.",
    "errGeneric": "تعذّر إرسال البريد. حاول مجددًا أو تواصل مع الدعم."
  },
  "resetPassword": {
    "title": "تعيين كلمة مرور جديدة",
    "subtitle": "أنشئ كلمة مرور قوية لحسابك",
    "newPasswordLabel": "كلمة المرور الجديدة",
    "newPasswordPlaceholder": "أدخل كلمة المرور الجديدة",
    "confirmPasswordLabel": "تأكيد كلمة المرور",
    "confirmPasswordPlaceholder": "أكّد كلمة المرور الجديدة",
    "requirementsHint": "8 أحرف على الأقل مع حرف كبير، صغير، ورقم",
    "resetPassword": "إعادة تعيين",
    "resetting": "جارٍ إعادة التعيين…",
    "successTitle": "تمت إعادة تعيين كلمة المرور!",
    "successBody": "يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
    "successToast": "تمت إعادة تعيين كلمة المرور بنجاح!",
    "goToLogin": "الذهاب إلى تسجيل الدخول",
    "invalidLinkTitle": "رابط غير صالح",
    "invalidLinkBody": "رابط إعادة التعيين غير صالح أو منتهي.",
    "requestNewLink": "طلب رابط جديد",
    "showPassword": "إظهار كلمة المرور",
    "hidePassword": "إخفاء كلمة المرور",
    "errInvalidLink": "رابط إعادة تعيين غير صالح",
    "errMismatch": "كلمتا المرور غير متطابقتين",
    "errTooShort": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    "errExpiredToken": "انتهى هذا الرابط أو هو غير صالح. اطلب رابطًا جديدًا.",
    "errNetwork": "تعذّر الاتصال بالخادم. تحقّق من اتصالك.",
    "errGeneric": "فشل إعادة التعيين. حاول مجددًا."
  },
  "tips": {
    "water1": "شرب الماء خلال 30 دقيقة من الاستيقاظ قد يحسّن الترطيب ومستويات الطاقة.",
    "water2": "كأس من الماء قبل كل وجبة طريقة لطيفة للبقاء قبل العطش.",
    "water3": "إضافة شريحة ليمون أو بضع أوراق نعناع تجعل الترطيب متعة.",
    "meals1": "إضافة حصة إضافية من الخضار يوميًا تدعم صحة الأمعاء والقلب.",
    "meals2": "حفنة من المكسرات أو البذور مع الفطور تثبّت طاقتك طوال الصباح.",
    "meals3": "الفاكهة الكاملة أفضل من العصير — الألياف تخفّف ارتفاع سكر الدم.",
    "steps1": "المشي 10 دقائق بعد الوجبات يساعد جسمك على معالجة السكريات بلطف أكثر.",
    "steps2": "تمدد 5 دقائق صباحًا يخفّف التوتر ويمنح يومك نَفَسًا هادئًا.",
    "steps3": "صعود الدرج مرة واحدة يوميًا يقوّي القلب بهدوء على مدى الأسابيع.",
    "sleep1": "خفض الإضاءة قبل النوم بساعة يساعد جسمك على الاسترخاء لنوم أعمق.",
    "sleep2": "وقت استيقاظ ثابت — حتى في عطلات نهاية الأسبوع — يثبّت دورة نومك.",
    "sleep3": "10 دقائق من شمس الصباح تنظّم إيقاع نومك بشكل طبيعي.",
    "general1": "دقيقتان من التنفس البطيء قد تخفضان التوتر وتثبّتان تركيزك.",
    "general2": "لاحظ لحظة امتنان واحدة اليوم — الانتصارات الذهنية الصغيرة تتراكم أيضًا.",
    "general3": "حضرت اليوم. تلك هي العادة التي تجعل كل عادة أخرى أسهل."
  },
  "factors": {
    "hydration": "الترطيب",
    "nutrition": "التغذية",
    "movement": "الحركة",
    "sleep": "النوم"
  },
  "nutritionDeep": {
    "sectionSnapshot": "ملخص التغذية اليومي",
    "sectionSnapshotSubtitle": "نظرة سريعة على الترطيب والسعرات وتوازن الوجبات اليوم.",
    "mealOptionsLoadFail": "تعذّر تحميل خيارات الوجبات",
    "prefsSaved": "تم حفظ تفضيلات الطعام! يتم تحديث الوجبات...",
    "prefsSaveFail": "تعذّر حفظ التفضيلات",
    "newOptionsFail": "تعذّر تحميل خيارات جديدة",
    "invalidZip": "الرجاء إدخال رمز بريدي صالح من 5 أرقام",
    "noVendorsArea": "لا يوجد موردون في هذه المنطقة بعد. نعمل على توسيع التغطية!",
    "vendorsFetchFail": "تعذّر جلب الموردين",
    "selectVendorFirst": "الرجاء اختيار مورد توصيل أولاً",
    "removedFromCart": "حُذف من السلة",
    "orderPlaced": "تم تأكيد الطلب بنجاح! 🎉",
    "enterZipFirst": "أدخل رمزك البريدي في قسم التوصيل أولاً",
    "mealNotAvailable": "هذه الوجبة غير متاحة للتوصيل في منطقتك بعد",
    "mealUnavailable": "هذه الوجبة غير متوفّرة لدى الموردين القريبين",
    "vendorOptionsFail": "تعذّر تحميل خيارات الموردين",
    "favoriteSaveFail": "تعذّر حفظ المفضّلة",
    "removedFromFavorites": "حُذف من المفضّلة",
    "favoriteRemoveFail": "تعذّر حذف المفضّلة",
    "cartEmpty": "سلّتك فارغة",
    "noMealOptions": "لا توجد خيارات وجبات متاحة",
    "loadingOptions": "جارٍ تحميل خيارات الوجبات...",
    "selectPreferences": "اختر تفضيلاتك الغذائية",
    "mealBuilder": "منشئ الوجبات",
    "myFavorites": "مفضّلتي",
    "myFavoriteMeals": "وجباتي المفضّلة",
    "noFavoritesYet": "لا توجد وجبات مفضّلة بعد!",
    "price": "السعر",
    "delivery": "التوصيل",
    "deliveryFee": "رسوم التوصيل",
    "distance": "المسافة",
    "subtotal": "المجموع الفرعي",
    "total": "الإجمالي",
    "orderNumber": "رقم الطلب",
    "vendor": "المورد",
    "totalAmount": "المبلغ الإجمالي",
    "estimatedDelivery": "وقت التوصيل المتوقّع",
    "whyThisMeal": "لماذا هذه الوجبة",
    "selectThisMeal": "اختر هذه الوجبة",
    "swapMeal": "استبدال الوجبة",
    "orderThisMeal": "اطلب هذه الوجبة",
    "notAvailableNearYou": "غير متاحة بقربك",
    "tryAdjustingPrefs": "حاول تعديل تفضيلاتك الغذائية لترى اقتراحات",
    "myMealPlanSummary": "خطّة وجباتي",
    "saveCompletePlan": "حفظ الخطة الكاملة",
    "yourFoodPreferences": "تفضيلاتك الغذائية",
    "editPreferences": "تعديل التفضيلات",
    "healthyMealDelivery": "توصيل الوجبات الصحية",
    "enableDelivery": "تفعيل التوصيل",
    "enterZipCode": "أدخل الرمز البريدي لعرض الوجبات المتاحة",
    "savePreferences": "حفظ التفضيلات",
    "quickAccessSavedMeals": "وصول سريع إلى وجباتك المحفوظة",
    "saveMealsFromBuilder": "احفظ الوجبات من تبويب منشئ الوجبات",
    "chooseVendor": "اختر موردًا لطلب هذه الوجبة",
    "yourCart": "سلّتك",
    "addMealsToStart": "أضف الوجبات من الخيارات أدناه للبدء",
    "orderPlacedDesc": "تم تنفيذ طلب وجبتك الصحية بنجاح",
    "continueShopping": "متابعة التسوّق",
    "trackOrder": "تتبّع الطلب",
    "healthyStoresTitle": "متاجر صحية وأسواق العافية القريبة منك",
    "healthyStoresIntro": "أنواع متاجر متنوعة ثقافياً يمكنك البحث عنها في منطقتك — لغرض الإلهام وليس التوصيل.",
    "healthyStoresGuidanceTitle": "إرشادات التسوق الصحي",
    "healthyStoresDisclaimer": "تقدم HealthLoop إلهاماً عاماً حول العافية والتسوق الصحي فقط — ولا تقدم نصائح طبية أو علاجية غذائية.",
    "healthyStores": {
      "organic": {
        "type": "متاجر الأغذية العضوية",
        "description": "منتجات طازجة خالية من المبيدات ومواد أساسية قليلة التصنيع.",
        "tags": [
          "أغذية كاملة",
          "منتجات طازجة"
        ]
      },
      "farmers": {
        "type": "أسواق المزارعين",
        "description": "فواكه وخضروات موسمية محلية ومنتجات تقليدية مباشرة من المزارعين.",
        "tags": [
          "محلي",
          "موسمي"
        ]
      },
      "african": {
        "type": "متاجر المنتجات الأفريقية الطازجة",
        "description": "اليام، والموز الذكر، والخضروات الورقية، وجوز النخيل، والمنتجات الأساسية من شرق وغرب أفريقيا.",
        "tags": [
          "ثقافي",
          "منتجات طازجة"
        ]
      },
      "caribbean": {
        "type": "أسواق الأغذية الكاريبية الطبيعية",
        "description": "الكالالو، والكاسافا، وفلفل سكوتش بونيه، والآكي، وفاكهة الخبز، والمنتجات الجزرية الأساسية.",
        "tags": [
          "ثقافي",
          "أغذية كاملة"
        ]
      },
      "asian": {
        "type": "سوبر ماركت الخضروات الآسيوية",
        "description": "بوك تشوي، والفجل الأبيض (دايكون)، وجذور اللوتس، والتوفو، والأعشاب الطازجة، والمنتجات الآسيوية الأساسية.",
        "tags": [
          "ثقافي",
          "منتجات طازجة"
        ]
      },
      "halal": {
        "type": "أسواق الأغذية الصحية الحلال",
        "description": "بروتينات قليلة الدهون معتمدة كحلال، ومنتجات طازجة، وتوابل تقليدية.",
        "tags": [
          "حلال",
          "ثقافي"
        ]
      },
      "mediterranean": {
        "type": "أسواق أغذية حوض المتوسط الكاملة",
        "description": "زيت الزيتون، والبقوليات، والأعشاب الطازجة، والحبوب الكاملة، والمنتجات الأساسية المتوسطية.",
        "tags": [
          "ثقافي",
          "أغذية كاملة"
        ]
      },
      "wellness": {
        "type": "متاجر أغذية تركز على العافية",
        "description": "أغذية كاملة منتقاة بعناية، وخيارات نباتية، ومنتجات خالية من المضافات الاصطناعية.",
        "tags": [
          "أغذية كاملة",
          "نباتي"
        ]
      }
    },
    "healthyShoppingTips": [
      "ابدأ بالتسوق من الجوانب الخارجية للمتجر أولاً — حيث توجد المنتجات الطازجة، والبروتينات قليلة الدهون، وبدائل الألبان عادةً.",
      "فضل الأغذية الكاملة ذات المكون الواحد على المنتجات المصنعة بكثافة.",
      "اختر المنتجات المحلية الموسمية — فهي عادةً ما تكون أكثر طزاجة، وأقل تكلفة، وأكثر غنى بالعناصر الغذائية.",
      "اسأل البائعين عن مصدر المنتجات وطرق زراعتها — سيسعد الكثيرون بمشاركة ذلك معك."
    ]
  },
  "messages": {
    "success": "Success!",
    "error": "Error",
    "saved": "Saved successfully",
    "updated": "Updated successfully",
    "deleted": "Deleted successfully",
    "confirmDelete": "Are you sure you want to delete this?",
    "networkError": "Network error. Please try again.",
    "somethingWrong": "Something went wrong",
    "failedToLoad": "Failed to load dashboard",
    "offlineMode": "Offline mode - showing limited data",
    "locationDenied": "Location access denied. Check browser settings to enable.",
    "locationUnavailable": "Location information unavailable",
    "locationTimeout": "Location request timed out. Please try again.",
    "locationError": "Unable to access location",
    "locationGranted": "Location access granted! Showing nearby options",
    "locationNotSupported": "Location services not supported by your browser",
    "requestingLocation": "Requesting location access..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Preventive Health Tracker",
    "educationHub": "Education Hub",
    "engagementWidget": "Engagement Widget",
    "wellnessCheckIn": "Wellness Check-In",
    "todaysMetrics": "Today's Metrics",
    "bloodPressure": "Blood Pressure",
    "heartRate": "Heart Rate",
    "weight": "Weight",
    "sleep": "Sleep",
    "waterIntake": "Water Intake",
    "exercise": "Exercise",
    "logMetric": "Log Metric",
    "viewHistory": "View History"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Health Reminders",
    "subtitle": "Stay on track with personalized health notifications",
    "breakfast": "Breakfast Reminder",
    "lunch": "Lunch Reminder",
    "dinner": "Dinner Reminder",
    "water": "Water Intake",
    "movement": "Movement Break",
    "sleep": "Sleep Reminder",
    "wellness": "Wellness Check-In",
    "healthLogging": "Health Logging",
    "annualCheckup": "Annual Checkup",
    "enable": "Enable",
    "disable": "Disable",
    "customize": "Customize Time",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "انضمّ إلى HealthLoop",
    "subtitle": "ابدأ رحلتك للوقاية الصحية اليوم",
    "fullName": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "confirmPassword": "تأكيد كلمة المرور",
    "createAccount": "إنشاء حساب",
    "haveAccount": "لديك حساب بالفعل؟",
    "signIn": "تسجيل الدخول",
    "creating": "يتم إنشاء الحساب...",
    "passwordTooShort": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
    "setupBiometric": "إعداد تسجيل الدخول بالبصمة",
    "setupBiometricDesc": "استخدم بصمتك أو Face ID أو Windows Hello لتسجيل دخول أسرع وأكثر أمانًا",
    "setupNow": "إعداد الآن",
    "skipForNow": "لاحقًا",
    "settingUp": "جارٍ الإعداد...",
    "benefit1": "لا داعي لتذكّر كلمات المرور",
    "benefit2": "أمان إضافي بالبصمة",
    "benefit3": "سجّل الدخول بلمسة أو نظرة",
    "biometricPrivacy": "بياناتك الحيوية لا تغادر جهازك",
    "biometricSuccess": "تم إعداد التسجيل بالبصمة! 🎉",
    "biometricFailed": "فشل إعداد التسجيل بالبصمة. يمكنك إعداده لاحقًا من الإعدادات.",
    "biometricSetupLater": "يمكنك إعداد التسجيل بالبصمة لاحقًا من ملفك الشخصي"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
